import ErrorExt from './error-ext.js';

const users = {};

/* users.refresh = (token) => {
  return users.getUser(token);
}; */

// sends token to server and if it's valid receives user (email, password
// (for couchdb), access_token (new), screenname, roles and db)
users.getUser = (token) => {
  console.log('---------------USERS refresh', token);
  return new Promise((resolve, reject) => {
    if (token) {
      fetch('/pass', { headers: { authorization: token } })
        .then(res => res.json())
        .then((res) => {
          if (res.error) {
            if (res.statusCode === 401) {
              reject(new ErrorExt(
                'Сессия просрочена. Войдите снова',
                {
                  error: 'Отказано в доступе',
                  statusCode: 401,
                },
              ));
            } else if (res.statusCode === 404) {
              reject(new ErrorExt(
                'Пользователь не найден',
                {
                  error: 'Отказано в доступе',
                  statusCode: 401,
                },
              ));
            } else if (res.statusCode === 429) {
              reject(new ErrorExt(
                'Превышен лимит',
                {
                  error: 'Отказано в доступе',
                  statusCode: 429,
                },
              ));
            } else {
              reject(res);
            }
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      reject(new ErrorExt(
        'Только для авторизованных пользователей',
        {
          error: 'Доступ запрещен',
          statusCode: 401,
        },
      ));
    }
  });
};

// save user data in couchdb
users.setData = (user, data) => {
  console.log('users.setData user', user);
  console.log('users.setData data', data);
  return new Promise((resolve, reject) => {
    fetch('/setuserdata', { method: 'POST', body: JSON.stringify(data), headers: { authorization: user.access_token } })
      .then(res => res.json())
      .then((res) => {
        console.log('setuserdata res', res);
        if (res.error) {
          reject(res);
        } else {
          resolve(res);
        }
      })
      .catch((err) => {
        console.log('setuserdata err', err);
        reject(err);
      });
  });
};

export default users;



// WEBPACK FOOTER //
// ./src/others/users.js